window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
	var focusClass = 'js-focus-hidden';

	$element.first()
	  .attr('tabIndex', '-1')
	  .focus()
	  .addClass(focusClass)
	  .one('blur', callback);

	function callback() {
	  $element.first()
		.removeClass(focusClass)
		.removeAttr('tabindex');
	}
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
	var hash = window.location.hash;

	// is there a hash in the url? is it an element on the page?
	if (hash && document.getElementById(hash.slice(1))) {
	  this.pageLinkFocus($(hash));
	}
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
	$('a[href*=#]').on('click', function(evt) {
	  this.pageLinkFocus($(evt.currentTarget.hash));
	}.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
	var eventName = options.namespace
	  ? 'focusin.' + options.namespace
	  : 'focusin';

	if (!options.$elementToFocus) {
	  options.$elementToFocus = options.$container;
	}

	options.$container.attr('tabindex', '-1');
	options.$elementToFocus.focus();

	$(document).on(eventName, function(evt) {
	  if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
		options.$container.focus();
	  }
	});
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
	var eventName = options.namespace
	  ? 'focusin.' + options.namespace
	  : 'focusin';

	if (options.$container && options.$container.length) {
	  options.$container.removeAttr('tabindex');
	}

	$(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
	var cookieEnabled = navigator.cookieEnabled;

	if (!cookieEnabled){
	  document.cookie = 'testcookie';
	  cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
	}
	return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
	for (var i = 0; i < array.length; i++) {
	  if (array[i][key] === value) {
		return array[i];
	  }
	}
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
	var i = array.length;
	while(i--) {
	  if (array[i][key] === value) {
		array.splice(i, 1);
		break;
	  }
	}

	return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
	var index = -1;
	var length = array == null ? 0 : array.length;
	var resIndex = 0;
	var result = [];

	while (++index < length) {
	  var value = array[index];
	  if (value) {
		result[resIndex++] = value;
	  }
	}
	return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
	return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
	var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

	options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
	var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

	options.$iframes.each(function() {
	  // Add wrapper to make video responsive
	  $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
	  
	  // Re-set the src attribute on each iframe after page load
	  // for Chrome's "incorrect iFrame content on 'back'" bug.
	  // https://code.google.com/p/chromium/issues/detail?id=395791
	  // Need to specifically target video and admin bar
	  this.src = this.src;
	});
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
	.on('shopify:section:load', this._onSectionLoad.bind(this))
	.on('shopify:section:unload', this._onSectionUnload.bind(this))
	.on('shopify:section:select', this._onSelect.bind(this))
	.on('shopify:section:deselect', this._onDeselect.bind(this))
	.on('shopify:section:reorder', this._onReorder.bind(this))
	.on('shopify:block:select', this._onBlockSelect.bind(this))
	.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
	var $container = $(container);
	var id = $container.attr('data-section-id');
	var type = $container.attr('data-section-type');

	constructor = constructor || this.constructors[type];

	if (typeof constructor === 'undefined') {
	  return;
	}

	var instance = $.extend(new constructor(container), {
	  id: id,
	  type: type,
	  container: container
	});

	this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
	var container = $('[data-section-id]', evt.target)[0];
	if (container) {
	  this._createInstance(container);
	}
  },

  _onSectionUnload: function(evt) {
	var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

	if (!instance) {
	  return;
	}

	if (typeof instance.onUnload === 'function') {
	  instance.onUnload(evt);
	}

	this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
	var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

	if (instance && typeof instance.onSelect === 'function') {
	  instance.onSelect(evt);
	}
  },

  _onDeselect: function(evt) {
	var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

	if (instance && typeof instance.onDeselect === 'function') {
	  instance.onDeselect(evt);
	}
  },

  _onReorder: function(evt) {
	var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

	if (instance && typeof instance.onReorder === 'function') {
	  instance.onReorder(evt);
	}
  },

  _onBlockSelect: function(evt) {
	var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

	if (instance && typeof instance.onBlockSelect === 'function') {
	  instance.onBlockSelect(evt);
	}
  },

  _onBlockDeselect: function(evt) {
	var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

	if (instance && typeof instance.onBlockDeselect === 'function') {
	  instance.onBlockDeselect(evt);
	}
  },

  register: function(type, constructor) {
	this.constructors[type] = constructor;

	$('[data-section-type=' + type + ']').each(function(index, container) {
	  this._createInstance(container, constructor);
	}.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
	if (typeof cents === 'string') {
	  cents = cents.replace('.', '');
	}
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || moneyFormat);

	function formatWithDelimiters(number, precision, thousands, decimal) {
	  precision = slate.utils.defaultTo(precision, 2);
	  thousands = slate.utils.defaultTo(thousands, ',');
	  decimal = slate.utils.defaultTo(decimal, '.');

	  if (isNaN(number) || number == null) {
		return 0;
	  }

	  number = (number / 100.0).toFixed(precision);

	  var parts = number.split('.');
	  var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
	  var centsAmount = parts[1] ? (decimal + parts[1]) : '';

	  return dollarsAmount + centsAmount;
	}

	switch (formatString.match(placeholderRegex)[1]) {
	  case 'amount':
		value = formatWithDelimiters(cents, 2);
		break;
	  case 'amount_no_decimals':
		value = formatWithDelimiters(cents, 0);
		break;
	  case 'amount_with_comma_separator':
		value = formatWithDelimiters(cents, 2, '.', ',');
		break;
	  case 'amount_no_decimals_with_comma_separator':
		value = formatWithDelimiters(cents, 0, '.', ',');
		break;
	}

	return formatString.replace(placeholderRegex, value);
  }

  return {
	formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
	if (typeof images === 'string') {
	  images = [images];
	}

	for (var i = 0; i < images.length; i++) {
	  var image = images[i];
	  this.loadImage(this.getSizedImageUrl(image, size));
	}
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
	new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
	var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

	if (match) {
	  return match[1];
	} else {
	  return null;
	}
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
	if (size === null) {
	  return src;
	}

	if (size === 'master') {
	  return this.removeProtocol(src);
	}

	var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

	if (match) {
	  var prefix = src.split(match[0]);
	  var suffix = match[0];

	  return this.removeProtocol(prefix[0] + '_' + size + suffix);
	} else {
	  return null;
	}
  }

  function removeProtocol(path) {
	return path.replace(/http(s)?:/, '');
  }

  return {
	preload: preload,
	loadImage: loadImage,
	imageSize: imageSize,
	getSizedImageUrl: getSizedImageUrl,
	removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
	this.$container = options.$container;
	this.product = options.product;
	this.singleOptionSelector = options.singleOptionSelector;
	this.originalSelectorId = options.originalSelectorId;
	this.enableHistoryState = options.enableHistoryState;
	this.currentVariant = this._getVariantFromOptions();

	$(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

	/**
	 * Get the currently selected options from add-to-cart form. Works with all
	 * form input elements.
	 *
	 * @return {array} options - Values of currently selected variants
	 */
	_getCurrentOptions: function() {
	  var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
		var $element = $(element);
		var type = $element.attr('type');
		var currentOption = {};

		if (type === 'radio' || type === 'checkbox') {
		  if ($element[0].checked) {
			currentOption.value = $element.val();
			currentOption.index = $element.data('index');

			return currentOption;
		  } else {
			return false;
		  }
		} else {
		  currentOption.value = $element.val();
		  currentOption.index = $element.data('index');

		  return currentOption;
		}
	  });

	  // remove any unchecked input values if using radio buttons or checkboxes
	  currentOptions = slate.utils.compact(currentOptions);

	  return currentOptions;
	},

	/**
	 * Find variant based on selected values.
	 *
	 * @param  {array} selectedValues - Values of variant inputs
	 * @return {object || undefined} found - Variant object from product.variants
	 */
	_getVariantFromOptions: function() {
	  var selectedValues = this._getCurrentOptions();
	  var variants = this.product.variants;
	  var found = false;

	  variants.forEach(function(variant) {
		var satisfied = true;

		selectedValues.forEach(function(option) {
		  if (satisfied) {
			satisfied = (option.value === variant[option.index]);
		  }
		});

		if (satisfied) {
		  found = variant;
		}
	  });

	  return found || null;
	},

	/**
	 * Event handler for when a variant input changes.
	 */
	_onSelectChange: function() {
	  var variant = this._getVariantFromOptions();

	  this.$container.trigger({
		type: 'variantChange',
		variant: variant
	  });

	  if (!variant) {
		return;
	  }

	  this._updateMasterSelect(variant);
	  this._updateImages(variant);
	  this._updatePrice(variant);
	  this.currentVariant = variant;

	  if (this.enableHistoryState) {
		this._updateHistoryState(variant);
	  }
	},

	/**
	 * Trigger event when variant image changes
	 *
	 * @param  {object} variant - Currently selected variant
	 * @return {event}  variantImageChange
	 */
	_updateImages: function(variant) {
	  var variantImage = variant.featured_image || {};
	  var currentVariantImage = this.currentVariant.featured_image || {};

	  if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
		return;
	  }

	  this.$container.trigger({
		type: 'variantImageChange',
		variant: variant
	  });
	},

	/**
	 * Trigger event when variant price changes.
	 *
	 * @param  {object} variant - Currently selected variant
	 * @return {event} variantPriceChange
	 */
	_updatePrice: function(variant) {
	  if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
		return;
	  }

	  this.$container.trigger({
		type: 'variantPriceChange',
		variant: variant
	  });
	},

	/**
	 * Update history state for product deeplinking
	 *
	 * @param {object} variant - Currently selected variant
	 */
	_updateHistoryState: function(variant) {
	  if (!history.replaceState || !variant) {
		return;
	  }

	  var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
	  window.history.replaceState({path: newurl}, '', newurl);
	},

	/**
	 * Update hidden master select of variant change
	 *
	 * @param {object} variant - Currently selected variant
	 */
	_updateMasterSelect: function(variant) {
	  $(this.originalSelectorId, this.$container)[0].value = variant.id;
	}
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
	addToCart: '[data-add-to-cart]',
	addToCartText: '[data-add-to-cart-text]',
	comparePrice: '[data-compare-price]',
	comparePriceText: '[data-compare-text]',
	originalSelectorId: '[data-product-select]',
	priceWrapper: '[data-price-wrapper]',
	productFeaturedImage: '[data-product-featured-image]',
	productJson: '[data-product-json]',
	productPrice: '[data-product-price]',
	productRewards: '[data-product-rewards]',
	productThumbs: '[data-product-single-thumbnail]',
	singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
	this.$container = $(container);

	// Stop parsing if we don't have the product json script tag when loading
	// section in the Theme Editor
	if (!$(selectors.productJson, this.$container).html()) {
	  return;
	}

	var sectionId = this.$container.attr('data-section-id');
	this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

	var options = {
	  $container: this.$container,
	  enableHistoryState: this.$container.data('enable-history-state') || false,
	  singleOptionSelector: selectors.singleOptionSelector,
	  originalSelectorId: selectors.originalSelectorId,
	  product: this.productSingleObject
	};

	this.settings = {};
	this.namespace = '.product';
	this.variants = new slate.Variants(options);
	this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

	this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
	this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

	if (this.$featuredImage.length > 0) {
	  this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
	  slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

	  this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
	}
  }

  Product.prototype = $.extend({}, Product.prototype, {

	/**
	 * Updates the DOM state of the add to cart button
	 *
	 * @param {boolean} enabled - Decides whether cart is enabled or disabled
	 * @param {string} text - Updates the text notification content of the cart
	 */
	updateAddToCartState: function(evt) {
	  var variant = evt.variant;

	  if (variant) {
		$(selectors.priceWrapper, this.$container).removeClass('hide');
	  } else {
		$(selectors.addToCart, this.$container).prop('disabled', true);
		$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
		$(selectors.priceWrapper, this.$container).addClass('hide');
		return;
	  }

	  if (variant.available) {
		$(selectors.addToCart, this.$container).prop('disabled', false);
		$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
	  } else {
		$(selectors.addToCart, this.$container).prop('disabled', true);
		$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
	  }
	},

	/**
	 * Updates the DOM with specified prices
	 *
	 * @param {string} productPrice - The current price of the product
	 * @param {string} comparePrice - The original price of the product
	 */
	updateProductPrices: function(evt) {
	  var variant = evt.variant;
	  var $comparePrice = $(selectors.comparePrice, this.$container);
	  var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

	  $(selectors.productPrice, this.$container)
		.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

	  $(selectors.productRewards, this.$container).html(variant.price / 10);

	  if (variant.compare_at_price > variant.price) {
		$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
		$compareEls.removeClass('hide');
	  } else {
		$comparePrice.html('');
		$compareEls.addClass('hide');
	  }
	},

	/**
	 * Updates the DOM with the specified image URL
	 *
	 * @param {string} src - Image src URL
	 */
	updateProductImage: function(evt) {
	  var variant = evt.variant;
	  var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

	  this.$featuredImage.attr('src', sizedImgUrl);
	},

	/**
	 * Event callback for Theme Editor `section:unload` event
	 */
	onUnload: function() {
	  this.$container.off(this.namespace);
	}
  });

  return Product;
})();

$(document).ready(function() {
	var $gallery = $('.gallery.js-slideshow'),
		$thumbs = $('.thumbnails.js-slideshow');       
				
	gallerySlideshow($gallery);        
	galleryThumbnails($thumbs);    
	productQTY();
	subscriptionSelected();
	pdpAccordion();
	videoPlayPause();    

	$('.responsive-table-row').each(function() {
		var inputField = $(this).find('.js-qty__input');
		adjustQTYColor(inputField);
	});    

	$('.selector-wrapper select, .rc_select').selectize({
		create: true
	});
	
	$(window).on('orientationchange resize', function () {   
		gallerySlideshow($gallery);          
		galleryThumbnails($thumbs);        
	});        
  });

  // Products Gallery Slider  
  function gallerySlideshow($carousel) {            
	$carousel.each(function () {
	  if (!$(this).hasClass('slick-initialized')) {
		$(this).slick({
			slidesToShow: 1,            
			slidesToScroll: 1,
			dots: true, 
			arrows: false,                  
			infinite: true,            
			mobileFirst: true,               
			asNavFor: '.thumbnails.js-slideshow',
			responsive: [
				{
					breakpoint: 970,
					settings: {
						fade: true,
						cssEase: 'linear',
						dots: false
					}
				}
			]
		});
	  }
	});    
  }

  // Products Gallery Thumbnails  
  function galleryThumbnails($carousel) {            
	$carousel.each(function () {
	  if (!$(this).hasClass('slick-initialized')) {
		$(this).slick({      
			slidesToShow: 6,       
			slidesToScroll: 1,
			dots: false, 
			arrows: false,
			centerMode: true,
			focusOnSelect: true,
			asNavFor: '.gallery.js-slideshow'                           
		});
	  }
	});    
  }    


function productQTY() {
	$('.js-qty__adjust--plus').on('click', function(e){        
		e.preventDefault();                
		var inputField = $(this).closest('.js-qty').find('.js-qty__input');
		var currentVal = parseInt(inputField.val());        
		
		if (!isNaN(currentVal)) {
			// Increment
			inputField.val(currentVal + 1);
			adjustQTYColor(inputField);
		} else {
			// Otherwise put a 1 there
			inputField.val(1);
		}        
	});
	
	$(".js-qty__adjust--minus").on('click', function(e) {    
		e.preventDefault();                
		var inputField = $(this).closest('.js-qty').find('.js-qty__input');
		var currentVal = parseInt(inputField.val());
		
		if (!isNaN(currentVal) && currentVal > 1) {
			// Decrement
			inputField.val(currentVal - 1);
			adjustQTYColor(inputField);
		} else {
			// Otherwise put a 1 there
			inputField.val(1);
		}        
	});        
}

function adjustQTYColor(inputField) {      
	if (inputField.val() > 1) {  	
		inputField.closest('.js-qty').find( "button.js-qty__adjust.js-qty__adjust--minus" ).addClass( "greater-than-one" );
	}
	else{
		inputField.closest('.js-qty').find( "button.js-qty__adjust.js-qty__adjust--minus" ).removeClass( "greater-than-one" );
	}    
}

function subscriptionSelected(){
	var ctaText = $('#AddToCart [data-add-to-cart-text]')
	var ctaPrice = $('#AddToCart [data-product-price]')
	var productRewards = $('[data-product-rewards]')
	var productRewardsPrice = $('[data-product-rewards]').data('product-rewards')
    var ctaMainPrice = $('.product-single__price-text')
    if ( !saveOgPrice ) {
      
    	var saveOgPrice = $('#og-product-price').text()
        }

	productRewards.text(Math.floor(parseFloat(productRewardsPrice / 100)))
	
	$('#rc_radio_options .rc_radio').on('change', function(){                                        
		var optionSelected = $(this),
			optionSelectedPrice,
			optionSelectedReward;

		if(optionSelected.val() === 'autodeliver') {
			optionSelectedPrice = optionSelected.closest('.rc_block').find('#rc_price_autodeliver').text();
			optionSelectedReward = Math.floor(parseFloat(optionSelectedPrice.replace('$', '')))

			ctaText.text('Add to Cart');
			ctaPrice.text('$ ' + optionSelectedPrice);            
			productRewards.text(optionSelectedReward);
          	ctaMainPrice.html('<s>' + saveOgPrice + '</s> ' + optionSelectedPrice);
          //ctaMainPrice.html(optionSelectedPrice);
          //console.log('<s>' + saveOgPrice + '</s> ' + optionSelectedPrice);
		}
		else {
			optionSelectedPrice = optionSelected.closest('.rc_block').find('#rc_price_onetime').text()
			optionSelectedReward = Math.floor(parseFloat(optionSelectedPrice.replace('$', '')))

			ctaText.text('Add to Cart')
			ctaPrice.text(optionSelectedPrice);                        
			productRewards.text(optionSelectedReward);
          	ctaMainPrice.text(optionSelectedPrice);
		}                               
	});
 }

 function pdpAccordion() {
	$('.tab-header').click(function(e) {                    
		$(this).closest('.tab').find('.tab-content').slideToggle(300);      
		$(this).closest('.tab').toggleClass('active');      
		$(this).closest('.tab').siblings().find('.tab-content').slideUp(300);
		$(this).closest('.tab').siblings().removeClass('active');                                               
	});
 }

// Video Section
function videoPlayPause() {
	var play = document.querySelector('#controls');
	var video = document.querySelector('#video-element');
	var video_container = document.querySelector('#player');
	var bg_image = document.querySelector('.bg-image');

	if (video_container) {
		play.addEventListener('click', function () {
			if (video.paused) {
				video.play();
				video_container.classList.add('playing');
				bg_image.style.display = 'none';
			} else {
				video.pause();
				video_container.classList.remove('playing');
			}
		}, false);
	}
}
$(document).ready(function() {
	discountBarToggle();    
	navOverlay();
	mmenuToggle();
	blogMMenuToggle();
}); 

function discountBarToggle() {        
	if(getCookie('DiscountBanner') != 'closed') {
		$('.discount-bar').css('display', 'flex');    
	}    
	$('.discount-bar #icon-close').on('click', function() {
		$(this).closest('.discount-bar').fadeOut().slideUp('slow');                        
		setCookie('DiscountBanner', 'closed', 1);                               

		mmenuPos();
	});        
}

// Nav Overlay
function navOverlay() {
	const $navOverlay = $('[data-nav-overlay]');
	const $navSubmenu = $('.level0 > .site_nav_has_submenu');

	$navSubmenu.mouseenter(function(e) {                                         
		//$navOverlay.addClass('nav-open');
	})
	.mouseleave(function(e) {                                             
		//$navOverlay.removeClass('nav-open');
	})
}

function mmenuToggle() {       
	$('#mmenu-trigger').on('click',function(event){
		event.preventDefault();
		$('body').toggleClass('mmenu-open');
		$(this).find('#nav-icon').toggleClass('open');
      	$('.site_nav_megamenu, .desktop-nav-inner').toggleClass('kion-show-menu');
      
		
		mmenuPos();
	}); // click 
}

function mmenuPos() {
	var header =  $('#header'),
		headerHeight =  header.height();

	if($('.discount-bar').css('display') == 'none') {
		$(header).find('.mobile-nav nav').css({
			'top': headerHeight,
			'height': 'calc(100% - 48px)'   
		});
	}
}

function blogMMenuToggle() {
	$('.blog-container .expand-icon').on('click', function() {
		$(this).closest('.blog-container').toggleClass('active');
		$(this).closest('.blog.site_nav_has_submenu').find('.site_nav_megamenu').slideToggle();        
	});
}

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
	  var c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
}

$(document).ready(function() {    
	backToTop();
	tooggleFooterLinks();
}); 

function backToTop() {
	$('#back-to-top').on('click', function () {    
		$('html, body').animate({scrollTop: 0}, 1000);
	});
}

function tooggleFooterLinks() {
	$('.footer-linklists .expand-icon').on('click', function () {    
		$(this).closest('.tab').toggleClass('active');
		$(this).closest('ul').find('.mobile-footer-links').slideToggle();
	});
}
$(document).ready(function() {        
	var totalString = $('.total').text().replace('$', ''),        
		total = parseFloat(totalString),
		freeShippingRemaining = (100 - total),
		freeShippingRemainingText = '$' + freeShippingRemaining.toFixed(2);

	setTimeout(function(){ 
		$('.calc-bar').addClass('loaded');         
		$('.loaded .progress').css('width', total + '%');

		if(total >= 100) {
			$('.calc-free-shipping').text('FREE');
			$('.calc-info').hide();
			$('.free-shipping-success').show();            
		} else {
			$('.free-shipping-remaining').text(freeShippingRemainingText);
			$('.calc-free-shipping').text('TBD');
			$('.calc-info').show();
			$('.free-shipping-success').hide();
		}        
	}, 1500);
});

$(document).ready(function() {

	var $articles = $('.article-container.js-slideshow'),
		$products = $('.products-container.js-slideshow, .collections-container.js-slideshow');
		$collectionNav = $('.collection-navigation'),
		$collection = $('.template-index .featured-collections-inner'),
		collection = $collection[0];
	
	//loader();
	articlesSlideshow($articles);     
	productsSlideshow($products);        
	collectionSlideshow($collection);  
	collectionNavSlideshow($collectionNav);  
	activeCollection();    
		
	if($('body').hasClass('template-index')){
	  collection.slick.setOption({
		swipe: false
	  });
	}    

	$(window).on('orientationchange resize', function () {   
		articlesSlideshow($articles);     
		productsSlideshow($products);
		collectionSlideshow($collection);
		collectionNavSlideshow($collectionNav);
		activeCollection();                        
	});        
});

// Articles Gallery Slider  
function articlesSlideshow($carousel) {            
	$carousel.each(function () {
	  if (!$(this).hasClass('slick-initialized')) {
		$(this).slick({
			centerMode: true,
			infinite: true,
			centerPadding: '41px',
			slidesToShow: 1,            
			variableWidth: false,
			dots: true, 
			arrows: false,                              
			mobileFirst: true,                           
			responsive: [
				{
					breakpoint: 769,
					settings: "unslick"
				}
			]
		});
	  }
	});    
  }

  // Products Gallery Slider  
function productsSlideshow($carousel) {            
	$carousel.each(function () {
	  if (!$(this).hasClass('slick-initialized')) {
		$(this).slick({            
			centerMode: true,
			infinite: true,
			centerPadding: '20px',
			slidesToShow: 1,            
			variableWidth: false,
			dots: true, 
			arrows: false,                              
			mobileFirst: true,                           
			responsive: [
				{
					breakpoint: 769,
					settings: "unslick"
				}
			]
		});        
	  }
	});            
  }  

// Products Gallery Slider  
function collectionSlideshow($carousel) {            
	$carousel.each(function () {
	  if (!$(this).hasClass('slick-initialized')) {
		$(this).slick({                        
			infinite: false,            
			slidesToShow: 1,                                                                        
			dots: false, 
			arrows: false,         
			asNavFor: '.collection-navigation',                     
			mobileFirst: true,                           
			responsive: [
				{
					breakpoint: 769,
					settings: "unslick"
				}
			]
		});
	  }
	});        
  }  

// Products Gallery Slider  
function collectionNavSlideshow($carousel) {            
	$carousel.each(function () {
	  if (!$(this).hasClass('slick-initialized')) {
		$(this).slick({                                    
			infinite: true,            
			slidesToShow: 2,                        
			slidesToScroll: 1,            
			dots: false, 
			variableWidth: true,
			arrows: true,                             
			asNavFor: '.featured-collections-inner',                         
			mobileFirst: true,  
			centerMode: false,
			focusOnSelect: true,       
			responsive: [
				{
					breakpoint: 769,
					settings: "unslick"
				}
			]
		});
	  }      
	});        
  }    

  // Active Collection
  function activeCollection() {              
	$('.collection-navigation li').on('click', function(event) {  
		event.preventDefault();      
		var collection = $('.featured-collection'),
			nav_item = $(this);                            

		if ($(window).width() > 768) {
			nav_item.addClass('active');
			nav_item.siblings().removeClass('active');                          
			
			collection.each(function(col) {                        
				if(nav_item.data('collection-nav') == $(this).data('collection')) {                                
					$(this).closest('.featured-collections-inner').find('.featured-collection').hide().removeClass('active');
					$(this).fadeIn().addClass('active');            
				}                
			});              
		}                                
	});
  }

  // Loader
  function loader() {       
	$('.loader-container').fadeOut();   
  }  
$(document).ready(function() {    
	rewardsFAQ();
});

function rewardsFAQ() {    
	$('.faq-block .swell-question').on('click', function() {        
		$(this).toggleClass('active');
		$(this).next().toggleClass('active');      		                                        
	});    
}
$(document).ready(function() {
	if($('body').hasClass('template-account')) {
		selectCurrentOption();
	}	
});

function selectCurrentOption(){
	var select	=	document.getElementById("accountNav"),
		link_account	=	document.querySelector(".account-link a"),
		link_orders		=	document.querySelector(".orders-link a");
	for( var _o=0; _o<select.options.length; _o++){
		var option	=	select.options[_o];
		if( option.value == window.location.pathname  + window.location.search){
			select.selectedIndex	=	_o;            
			break;
		}//if
	}//for
	
	if(window.location.pathname == '/account'){		
		link_orders.classList.remove('active-link');
		link_account.classList.add('active-link');            				
	}//if		
	if( window.location.pathname + window.location.search == '/account?view=orders'){
		link_account.classList.remove('active-link');
		link_orders.classList.add('active-link');            				            		
	}//if			
}//function

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
	return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
	new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
	  hideElement: 'AddressProvinceContainerNew'
	});
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
	var formId = $(this).data('form-id');
	var countrySelector = 'AddressCountry_' + formId;
	var provinceSelector = 'AddressProvince_' + formId;
	var containerSelector = 'AddressProvinceContainer_' + formId;

	new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
	  hideElement: containerSelector
	});
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
	$newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
	var formId = $(this).data('form-id');
	$('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
	var $el = $(this);
	var formId = $el.data('form-id');
	var confirmMessage = $el.data('confirm-message');
	if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
	  Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
	}
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
	recoverPasswordForm: '#RecoverPassword',
	hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
	return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
	evt.preventDefault();
	toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
	var hash = window.location.hash;

	// Allow deep linking to recover password form
	if (hash === '#recover') {
	  toggleRecoverPasswordForm();
	}
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
	$('#RecoverPasswordForm').toggleClass('hide');
	$('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
	var $formState = $('.reset-password-success');

	// check if reset password form was successfully submited.
	if (!$formState.length) {
	  return;
	}

	// show success message
	$('#ResetSuccess').removeClass('hide');
  }
})();



$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
	slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
	$tables: $(tableSelectors),
	tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
	'.rte iframe[src*="youtube.com/embed"],' +
	'.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
	$iframes: $(iframeSelectors),
	iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
	document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

$(document).ready(function() {
  thumbnails = $('img[src*="/products/"]').not(':first');
  if (thumbnails.length) {
    thumbnails.bind('click', function() {
      var arrImage = $(this).attr('src').split('?')[0].split('.');
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
      var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
      if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
           optionValue = variantImages[strNewImage]['option-'+i];
           if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
             $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
           }
        });
      }
    });
  }
});
